import { addEllipsis } from "src/shared/utilities/addEllipsis";

const formatAddressForDesktop = address => addEllipsis(address, 38);

const formatAddressForMobile = address => addEllipsis(address, 22);

const formatPath = url => new URL(url).pathname;

export { formatAddressForDesktop, formatAddressForMobile, formatPath };
